export const customerAccountFilterState = () => ({
  searchKey: '',
  product: null,
  page: 1,
  perPage: 10,
  orderBy: 'createdAt',
  order: 'desc'
});
